import React from 'react';
import { motion } from 'framer-motion';
import { HandHeart, Scale, Brain, Sparkles, Users, Battery, TrendingUp } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function DeschideBenefits() {
  const benefits = [{
    icon: HandHeart,
    title: 'Înveți să primești fără vinovăție',
    desc: 'Nu te mai simți prost când primești ceva bun. Înveți că a primi e la fel de important ca a da și că meriți abundență în viața ta.'
  }, {
    icon: Scale,
    title: 'Creezi echilibru între a da și a primi',
    desc: 'Nu te mai golești dând totul celorlalți. Găsești echilibrul în care oferi cu bucurie și primești la fel, fără luptă și fără efort excesiv.'
  }, {
    icon: Brain,
    title: 'Obții o stare de pace interioară rapidă',
    desc: 'Prin meditația din curs accesezi liniștea minții în câteva minute. O practici oricând simți că stresul te copleșește.'
  }, {
    icon: Sparkles,
    title: 'Accesezi o energie de abundență reală',
    desc: 'Nu doar mentalitate pozitivă de suprafață, ci o stare interioară din care lucrurile bune vin natural: oportunități, bani, conexiuni, claritate.'
  }, {
    icon: Users,
    title: 'Îți îmbunătățești relațiile',
    desc: 'Când te simți în echilibru cu tine, relațiile cu ceilalți se transformă. Cu partenerul, cu colegii, cu familia. Totul devine mai armonios.'
  }, {
    icon: Battery,
    title: 'Îți crești nivelul de energie și claritate',
    desc: 'Nu te mai simți obosită și confuză. Ai mai multă energie, mai multă claritate și mai multă putere de a face lucrurile care contează.'
  }, {
    icon: TrendingUp,
    title: 'Începi să vezi rezultate concrete în viața ta',
    desc: 'Oportunități care apar, bani care vin mai ușor, relații care se îmbunătățesc. Nu e magie. E rezultatul unei schimbări interioare reale.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1010">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1011">
        <SectionHeading title="Ce se schimbă concret după acest curs" data-id="element-1012" />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1013">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="bg-brand-cream rounded-3xl p-8 text-center hover:shadow-warm transition-shadow duration-300 border border-brand-text/5" data-id="element-1014">
                <div className="w-16 h-16 mx-auto bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-1015">
                  <Icon className="w-8 h-8" data-id="element-1016" />
                </div>
                <h3 className="font-bold text-xl text-brand-text mb-4" data-id="element-1017">
                  {benefit.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-1018">
                  {benefit.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1019">
          <CTAButton data-id="element-1020" />
        </motion.div>
      </div>
    </section>;
}